import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M2.75 16.171a3.685 3.685 0 0 0 3.685 3.684h11.13a3.685 3.685 0 0 0 3.685-3.684M12 4.13v12.04M9.085 7.058 12 4.13l2.916 2.928"
    }, null, -1)
  ]))]))
}
export default { render: render }